import React from 'react';
import PropTypes from 'prop-types';
import { usePrefs, useLabels } from 'wsm-common-data';
import PaymentSelector from './PaymentSelector';
import SpecialsDisplay from './SpecialsDisplay';
import StepCtas from './StepCtas';
import useUdsLeadGate from '../hooks/useUdsLeadGate';
import usePaymentData from '../hooks/usePaymentData';
import { UDS_LEAD_GATE } from '../constants';

import './PaymentSelector.scss';

const UdsLeadGateOverlay = ({ text = '' }) => {
	const handleClick = (e) => {
		e.preventDefault();
		document.getElementById('mmd-widget')?.scrollIntoView({ behavior: 'smooth' });
	};

	return (
		<div className="payment-unavailable">
			<div className="payment-unavailable-content">
				<p className="payment-unavailable-title">
					<a
						href="#mmd-widget"
						aria-label={text}
						role="button"
						onClick={handleClick}
					>
						{text}
					</a>
				</p>
			</div>
		</div>
	);
};

const PaymentSelectorView = () => {
	const labels = useLabels();
	const { enableIncentives, showCTAs } = usePrefs();
	const isLeadGateActive = useUdsLeadGate();
	const [isLoading, hasError, paymentData] = usePaymentData();

	return (
		<>{isLeadGateActive
			?
				<UdsLeadGateOverlay text={labels.get(UDS_LEAD_GATE)} />
			:
				<>
					<PaymentSelector
						key="track-my-offer-payment-selector"
						isLoading={isLoading}
						hasError={hasError}
						paymentData={paymentData}
					/>
					{enableIncentives === 'true' && (
						<SpecialsDisplay
							key="track-my-offer-specials-display"
							isLoading={isLoading}
							hasError={hasError}
							paymentData={paymentData} 
						/>
					)}
					{showCTAs === 'true' && <StepCtas key="track-my-offer-ctas" />}
				</>
			}
		</>
	);
};


UdsLeadGateOverlay.propTypes = {
	text: PropTypes.string
};

export default PaymentSelectorView;